import { render, staticRenderFns } from "./InputRicerca.vue?vue&type=template&id=ec14bae8&scoped=true&"
import script from "./InputRicerca.vue?vue&type=script&lang=js&"
export * from "./InputRicerca.vue?vue&type=script&lang=js&"
import style0 from "./InputRicerca.vue?vue&type=style&index=0&id=ec14bae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec14bae8",
  null
  
)

export default component.exports